export default __webpack_public_path__ + "static/jdedwards-52cd02ae3c2f1d5cb7e0b4388aac0562.svg";